const { sumBy } = require('lodash');

module.exports = function(value) {
  return value.meals
    .map(({ name, dates = [] }) => `${name} (${sumBy(dates, 'quantity')})`)
    .join(', ');
};
